import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PaymentCancelledPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50">
      <div className="bg-white p-6 rounded-xl shadow-md text-center max-w-md">
        <h2 className="text-2xl font-bold text-red-600 mb-2">
          {t('payment.cancelTitle', 'Payment Cancelled')}
        </h2>
        <p className="text-gray-700 text-sm mb-4">
          {t('payment.cancelMessage', 'Your payment was cancelled. No charges were made.')}
        </p>
        <button
          onClick={() => navigate('/explorer')}
          className="mt-4 bg-red-500 text-white py-2 px-4 rounded-full hover:bg-red-600 transition"
        >
          {t('payment.backHome', 'Back to Home')}
        </button>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
